import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var DashboardService = /** @class */ (function () {
    function DashboardService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    DashboardService.prototype.getServerSentEvent = function (url) {
        var _this = this;
        return Observable.create(function (observer) {
            var es = _this._sseService.getEventSource(url);
            es.onmessage = function (event) {
                _this._zone.run(function () { return observer.next(event); });
            };
            es.onerror = function (error) {
                observer.error(error);
            };
        });
    };
    DashboardService.prototype.loadProfile = function (data) {
        return this.http.post("loadProfile", data);
    };
    DashboardService.prototype.parameterConfig = function (transformerid) {
        return this.http.get("getParameterConfig?transformerid=" + transformerid);
    };
    DashboardService.prototype.getWeatherData = function (data) {
        return this.http.get("https://api.openweathermap.org/data/2.5/weather?lat=" + data.latitude + "&lon=" + data.longitude + "5&appid=d519f7e16e00303bc0e8e9b0850ead0a");
    };
    DashboardService.prototype.getTransformerHealthIndex = function (getTransformerData) {
        return this.http.get("getHealthIndex?transformerID=" + getTransformerData);
    };
    DashboardService.prototype.transformerDowntime = function (body) {
        return this.http.post("getTransformerDowntime", body);
    };
    DashboardService.prototype.getHvLvDiff = function (body) {
        return this.http.post("getHVLVReport", body);
    };
    DashboardService.prototype.alertCount = function (body) {
        return this.http.post("alertCount", body);
    };
    DashboardService.prototype.transformerCount = function (body) {
        return this.http.post("transformerCount", body);
    };
    DashboardService.prototype.loadIndividualDashboard = function (body) {
        return this.http.post("loadIndividualDashboard", body);
    };
    DashboardService.prototype.transformerTileData = function (body) {
        return this.http.post("transformerTileData", body);
    };
    DashboardService.prototype.kwhData = function (data) {
        return this.http.post("getKWHDATA", data);
    };
    DashboardService.prototype.getLatestAlerts = function (body) {
        return this.http.post("getLatestAlerts", body);
    };
    DashboardService.prototype.getLastUpdatedAlertsData = function (body) {
        return this.http.post("getLastUpdatedAlertsData", body);
    };
    DashboardService.prototype.getSimReport = function () {
        return this.http.get("getSimData");
    };
    DashboardService.prototype.getTapPositionData = function (transformerid) {
        return this.http.get("getTapPositionData?transformerid=" + transformerid);
    };
    DashboardService.prototype.getRenewalDate = function (userid) {
        return this.http.get("getRenewalDate?userid=" + userid);
    };
    DashboardService.prototype.getRenewalInvoice = function (userid) {
        return this.http.post("getRenewalInvoice?userid", userid, { responseType: 'blob' });
    };
    DashboardService.prototype.updateUserRenewalDate = function (userData) {
        return this.http.post("updateUserRenewalDate", userData);
    };
    DashboardService.prototype.updateCheckStatus = function (userid) {
        return this.http.get("updateCheckStatus?userid=" + userid);
    };
    DashboardService.prototype.generateProformaInvoice = function (userid) {
        return this.http.post("generateProformaInvoice?userid", userid, { responseType: 'blob' });
    };
    DashboardService.prototype.updateUTRNumber = function (data) {
        return this.http.post("updateUTRNumber", data);
    };
    DashboardService.prototype.getDeviceStatus = function (data) {
        return this.http.post("getDeviceConnectionStatus", data);
    };
    DashboardService.prototype.gethealthSatus = function (data) {
        return this.http.post("getHealthStatus", data);
    };
    DashboardService.prototype.getTransformerLatestData = function (data) {
        return this.http.post("getTransformerLatestData", data);
    };
    DashboardService.prototype.getTransformerActiveAlert = function (data) {
        return this.http.post("getTransformerActiveAlert", data);
    };
    DashboardService.prototype.aiModule = function (data) {
        return this.http.post("aiModule", data);
    };
    DashboardService.prototype.getRelativePressure = function (data) {
        return this.http.post("getRelativePressure", data);
    };
    //test_amc_dummy_remove_after_test
    DashboardService.prototype.getamcreport = function () {
        return this.http.get("getamcreport");
    };
    DashboardService.prototype.addAMC = function (amcData) {
        console.log("amcData", amcData);
        return this.http.post("addamc", amcData);
    };
    DashboardService.prototype.updateAMC = function (amcData) {
        return this.http.put("updateamc", amcData);
    };
    DashboardService.prototype.getamcids = function () {
        return this.http.get("getamcids");
    };
    DashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: DashboardService, providedIn: "root" });
    return DashboardService;
}());
export { DashboardService };
